import { render, staticRenderFns } from "./RegisterDefault.vue?vue&type=template&id=edeae5f4&"
import script from "./RegisterDefault.vue?vue&type=script&lang=js&"
export * from "./RegisterDefault.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports